import React, { useState, useEffect } from 'react';
import { RadioGroup, FormControlLabel, Radio, Box, Stack, Button, TextareaAutosize } from '@mui/material';
import { useNavigate } from "react-router-dom";
import axios from "../../utils/fvAxios";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ToastContainer, toast } from "react-toastify";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function StartPrequlications() {
  const [selectedClient, setSelectedClient] = useState(null);
  console.log(selectedClient);
  const [isLoading, setIsLoading] = useState(false);
  const [showRadioGroup, setShowRadioGroup] = useState(true);
  // const [startprq, setstartprq] = useState([]);
  // const [getpqid, setpqid] = useState();
  // const [error, setError] = useState(null);
  // const [isLoading, setIsLoading] = useState(true); 
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  // const vendor = params.get("Vendor");
  // const multi = params.get("ismulti");
  // const client = params.get("clientSelection");
  const startpq = params.get("startprq");
  const Pqid = params.get("pqid");
  const parsedObject = JSON.parse(startpq);
  const InvitationClient = params.get("InvitationClient");
  const InvitationVendor = params.get("InvitationVendor");
  const InvitationIsMultiClient = params.get("InvitationIsMultiClient");

  const [InvitationTemplates, setInvitationTemplates] = React.useState([]);

  const handleClientChange = (event) => {
    const selectedClientId = event.target.value;
    if (InvitationTemplates?.length > 0) {
      const selectedClientTemplate = InvitationTemplates?.find((client) => client.clientTemplateId === selectedClientId);
      setSelectedClient(selectedClientTemplate);
    } else {
      const selectedClientTemplate = parsedObject?.find((client) => client.clientTemplateId === selectedClientId);
      setSelectedClient(selectedClientTemplate);
    }

  };
  const [textareaValue, setTextareaValue] = useState('');
  const handleTextareaChange = (event) => {
    const newValue = event.target.value;
    setTextareaValue(newValue);
  };
  const [open, setOpen] = React.useState(false);

  const handleContinueClick = () => {
    if (selectedClient?.lockedByDefault) {
      setOpen(true);
    } else {
      handleClose1()
    }
  };
  const Nocoment = textareaValue.length == 0 ? "" : textareaValue;
  const [Dis, setDis] = React.useState(false);
  const handleClose1 = () => {
    setDis(true);
    setIsLoading(true);
    const data = {
      pqId: Pqid,
      clientTemplateId: selectedClient?.clientTemplateId,
      comments: Nocoment,

    };
    axios
      .post(
        "Prequalification/UpdateQuestionnaireTemplate?pqId", data,
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (res?.data?.responseCode == "100") {
          toast.success(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setOpen(false);
          if (res?.data?.data.errorMessage == "Questionnaire Locked. Redirect to dashboard") { navigate("/DashBoard"); } else { navigate("/vendordetails?pqid=" + res?.data?.data?.prequalificationId + "&tab=Questionnaire"); }
          // setTimeout(() => {
          //   navigate("/vendordetails?pqid="+res?.data?.data?.prequalificationId);
          // }, 2000);
        } else {
          toast.error(res?.data?.data?.errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setOpen(false);
        }

      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
        setDis(false);
      });

    // if(Nocoment==null){
    //   axios
    //   .post(
    //      "Prequalification/UpdateQuestionnaireTemplate?pqId="+Pqid+"&clientTemplateId="+selectedClient?.clientTemplateId,
    //     {
    //       headers: { "Content-Type": "application/json" },
    //     }
    //   )
    //   .then((res) => {
    //     if (res?.data?.responseMessage == "Success") {
    //       toast.success(res?.data?.responseMessage, {
    //         position: "top-right",
    //         autoClose: 4000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: "light",
    //       });
    //       setOpen(false);
    //       navigate("/vendordetails?pqid="+Pqid);
    //     } else {
    //       toast.error(res?.data.responseMessage, {
    //         position: "top-right",
    //         autoClose: 5000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: "light",
    //       });
    //       setOpen(false);
    //     }

    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });}else{
    //     axios
    //     .post(
    //        "Prequalification/UpdateQuestionnaireTemplate?pqId="+Pqid+"&clientTemplateId="+selectedClient?.clientTemplateId+"&comments="+Nocoment,
    //       {
    //         headers: { "Content-Type": "application/json" },
    //       }
    //     )
    //     .then((res) => {
    //       if (res?.data?.responseMessage == "Success") {
    //         toast.success(res?.data?.responseMessage, {
    //           position: "top-right",
    //           autoClose: 4000,
    //           hideProgressBar: false,
    //           closeOnClick: true,
    //           pauseOnHover: true,
    //           draggable: true,
    //           progress: undefined,
    //           theme: "light",
    //         });
    //         setOpen(false);
    //         navigate("/vendordetails?pqid="+Pqid);
    //       } else {
    //         toast.error(res?.data.responseMessage, {
    //           position: "top-right",
    //           autoClose: 5000,
    //           hideProgressBar: false,
    //           closeOnClick: true,
    //           pauseOnHover: true,
    //           draggable: true,
    //           progress: undefined,
    //           theme: "light",
    //         });
    //         setOpen(false);
    //       }

    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    //   }


  };



  useEffect(() => {
    if (InvitationClient && InvitationVendor && InvitationIsMultiClient) {
      axios
        .post("Prequalification/StartQuestionnaire?clientId=" + InvitationClient + "&vendorId=" + InvitationVendor + "&isMultiClient=" + InvitationIsMultiClient)
        .then((res) => {
          if (res?.data) {
            setInvitationTemplates(res?.data?.data?.templates);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
  };



  const handleCancleclick = () => {
    navigate(
      "/DashBoard")
  };
  const isContinueButtonDisabled = () => {
    return !selectedClient || (selectedClient?.lockedByDefault && textareaValue.trim().length === 0);
  };
  return (
    <div style={{ padding: "20px" }}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}

      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "416px",
            },
          },
        }}

      >
        <DialogTitle id="alert-dialog-title">
          {"Your description has been submitted for review"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p>  We will unlock the questionnaire if you are authorized for this risk level.</p>
            <p>Please contact us at <span style={{ fontWeight: "bold" }}>402-562-5930</span> or <span style={{ color: "#0875B1", fontWeight: "bold" }}>info@firstverify.com </span>if you have any questions. Click OK to go to your dashboard.</p>
          </DialogContentText>
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={handleClose}>Disagree</Button>
        
        </DialogActions> */}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "20px" }}>
          <Button variant="contained" color="primary" disabled={Dis} onClick={handleClose1} sx={{ padding: "19px", width: "160px" }}>Ok</Button>
        </div>

      </Dialog>

      <Box style={{ backgroundColor: "#fff", padding: "20px", paddingBottom: "30px" }}>
        {/* <div>
    {isLoading ? <Backdrop
 sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
 open={isLoading}

 >
<CircularProgress color="inherit" />
 </Backdrop>: ( */}
        <>
          {/* {showRadioGroup && ( */}
          <h5 style={{ color: "#3E4A62" }}>Prequalification Questionnaire</h5>
          <hr />
          <RadioGroup name="client" value={selectedClient?.clientTemplateId || ""} onChange={handleClientChange}  >
            <div hidden={InvitationTemplates?.length == 0}>
              {InvitationTemplates?.map((client, index) => (
                <div key={index}>
                  <FormControlLabel
                    value={client?.clientTemplateId}
                    control={<Radio />}
                    label={<b style={{ fontSize: "16px" }}>{client?.templateName}</b>}
                  />
                  <br />
                  <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                    {client?.templateNotes}
                  </span>
                  <br />
                </div>
              ))}
            </div>
            <div>
              {parsedObject?.map((client, index) => (
                <div key={index}>
                  <FormControlLabel
                    value={client?.clientTemplateId}
                    control={<Radio />}
                    label={<b style={{ fontSize: "16px" }}>{client?.templateName}</b>}
                  />
                  <br />
                  <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                    {client?.templateNotes}
                  </span>
                  <br />
                </div>
              ))}
            </div>
          </RadioGroup>


          {selectedClient && selectedClient.lockedByDefault && (
            <div style={{ marginTop: "20px" }}>
              <span style={{ color: "#3E4A62" }}>Describe the work you will be performing for this client (and locations where the work will be performed). <span style={{ color: "red" }}>*</span></span>
              <TextareaAutosize
                maxRows={4}
                aria-label="maximum height"
                placeholder=""
                color="secondary"
                style={{ width: "100%", height: "128px" }}
                value={textareaValue}
                onChange={handleTextareaChange}
              />
            </div>
          )}
          <br />
          <div style={{ marginBottom: "20px" }}>
            <Stack direction="row" spacing={2} style={{ float: "right" }}>
              <Button variant="outlined" sx={{ padding: "15px" }} onClick={handleCancleclick}>Cancel</Button>
              <Button variant="contained" onClick={handleContinueClick} disabled={isContinueButtonDisabled()}>Start Prequalification --{">"}</Button>
            </Stack>
          </div>

        </>
        {/* )}
        </div> */}
      </Box>

    </div>
  )
}
